/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { TEventInputData } from '@/core/constants/event_types/additional_types';
import { Logger } from '@/shared/logger/logger';

export function isValidEventInputData(obj: any): obj is TEventInputData | null {
  if (obj === null || obj === undefined) {
    Logger.info('Null or undefined event input data');
    return true;
  }

  if (typeof obj !== 'object') {
    Logger.warn('Invalid input: expected an object or null');
    return false;
  }

  const eventDataKeys = [
    'cart',
    'oid',
    'onb',
    'tags',
    'cen',
    'cart',
    'product',
    'pay_methods',
    'amount',
    'cv_data',
  ];

  const eventInputDataKeys = ['eventData', 'cdas'];

  if (!eventInputDataKeys.every(key => key in obj)) {
    Logger.warn(
      `Invalid input: missing required keys in object. Expected keys: ${eventInputDataKeys}`,
    );
    return false;
  }

  if (typeof obj.eventData !== 'object' || obj.eventData === null) {
    Logger.warn('Invalid input: eventData should be an object');
    return false;
  }

  if (!Object.keys(obj.eventData).every(key => eventDataKeys.includes(key))) {
    Logger.warn(
      `Invalid input: eventData contains invalid keys. Allowed keys: ${eventDataKeys}`,
    );
    return false;
  }

  if (
    obj.browserData !== undefined &&
    (typeof obj.browserData !== 'object' || obj.browserData === null)
  ) {
    Logger.warn('Invalid input: browserData should be an object if defined');
    return false;
  }

  if (!Array.isArray(obj.cdas)) {
    Logger.warn('Invalid input: cdas should be an array');
    return false;
  }

  return true;
}
